/**
 * Authentication Guard
 * Ensures user is authenticated before accessing protected routes
 * Uses the platform JWT token for authentication validation
 */

import { redirect } from '@tanstack/react-router';
// import { authService } from '../../services/auth.service';
import { getAccessToken } from '../../utils/auth-token';
import { STORAGE_KEYS } from '../../types/route.types';

/**
 * Check if user is authenticated
 * Used in route beforeLoad hooks to protect routes
 *
 * @returns User data from cached sessionStorage
 * @throws Error if user is not authenticated
 */
export const requireAuth = async () => {
  try {
    const cachedToken = getAccessToken();

    if (!cachedToken) {
      console.log('[requireAuth] ❌ No access token found');
      if (typeof window !== 'undefined') {
        window.sessionStorage.removeItem(STORAGE_KEYS.USER_DATA);
      }
      throw redirect({ to: '/login' });
    }

    console.log('[requireAuth] ✅ Valid access token found');

    // Get cached user data from sessionStorage
    const userData = sessionStorage.getItem(STORAGE_KEYS.USER_DATA);

    if (userData) {
      try {
        return JSON.parse(userData);
      } catch (error) {
        console.error('[requireAuth] ❌ Failed to parse cached user data');
        sessionStorage.removeItem(STORAGE_KEYS.USER_DATA);
      }
    }

    console.log('[requireAuth] ⚠️ Valid token found but no cached user data');
    return null;
  } catch (error) {
    console.error('[requireAuth] ❌ Authentication check failed:', error);
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem(STORAGE_KEYS.USER_DATA);
    }
    throw redirect({ to: '/login' });
  }
};
